module.exports = __webpack_public_path__ + "assets/img/768_menu_img_bg_left.437d9961.svg";